import { useEffect } from "react";

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

// SEO head manager: title, meta description, canonical, OG + optional JSON-LD schema.
export default function Seo({ title, description, path = "", schema = null }) {
  useEffect(() => {
    const fullTitle = title
      ? (title.includes("Animaverde") ? title : `${title} | Animaverde`)
      : "Animaverde | Cura e passione per il tuo verde";
    document.title = fullTitle;
    if (description) {
      upsertMeta("name", "description", description);
      upsertMeta("property", "og:description", description);
    }
    upsertMeta("property", "og:title", fullTitle);

    const url = `https://www.giardinianimaverde.it${path}`;
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);
    upsertMeta("property", "og:url", url);

    let script = document.getElementById("av-jsonld");
    if (schema) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "av-jsonld";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(schema);
    } else if (script) {
      script.remove();
    }
  }, [title, description, path, schema]);

  return null;
}
